import { useMemo } from 'react';
import useKey from 'react-use/lib/useKey';
const useShortcut = _ref => {
  let {
    disabled = false,
    handler,
    options,
    shortcut
  } = _ref;
  const {
    ctrlKey = false,
    key,
    metaKey = false,
    shiftKey = false
  } = shortcut;
  const predicate = useMemo(() => {
    return event => {
      if (disabled === false && key === event.key && ctrlKey === Boolean(event.ctrlKey) && shiftKey === Boolean(event.shiftKey) && metaKey === Boolean(event.metaKey)) {
        return true;
      }
      return false;
    };
  }, [disabled, key, ctrlKey, metaKey, shiftKey]);
  useKey(predicate, handler, options, [predicate, handler, options]);
};
export default useShortcut;